<template>
  <!-- <vue-scroll class="deposit-tab" @ps-scroll-up="scrollHanle" @ps-scroll-down="scrollHanle" ref="depositType"> -->
  <div class="deposit-tab" ref="depositType">
    <div class="page-deposit-type">
      <bCardHeader :param="param" :buttons="buttons"></bCardHeader>
      <el-tabs class="deposit-type" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('deposit.index.online_bank_deposit')" class="deposit-tabs" name="online_bank_deposit">
          <bDepositType :step="stepInfo.online_bank_deposit"></bDepositType>
        </el-tab-pane>
        <el-tab-pane :label="$t('deposit.index.atm_transfer_deposit')" name="atm_transfer_deposit">
          <bDepositType :step="stepInfo.atm_transfer_deposit"></bDepositType>
        </el-tab-pane>
        <el-tab-pane :label="$t('deposit.index.bank_transfer_deposit')" name="bank_transfer_deposit">
          <bDepositType :step="stepInfo.bank_transfer_deposit"></bDepositType>
        </el-tab-pane>
        <el-tab-pane :label="$t('deposit.index.cheque_deposit')" name="cheque_deposit">
          <bDepositType :step="stepInfo.cheque_deposit"></bDepositType>
        </el-tab-pane>
        <el-tab-pane :label="$t('deposit.index.fps_deposit')" name="fps_deposit">
          <bDepositType :step="stepInfo.fps_deposit"></bDepositType>
        </el-tab-pane>
        <!-- <el-tab-pane v-if="subAccountLength && userInfo.type !== 'COMPANY'" :label="$t('deposit.index.sub_account_deposit')"
          name="sub_account_deposit">
          <bDepositType :step="stepInfo.sub_account_deposit"></bDepositType>
        </el-tab-pane> -->
      </el-tabs>
      <el-dialog :title="dialogtitle" :visible.sync="showDialog" width="30%" class="hsbc-dialog" :show-close="false">
        <div class="dialog-info">{{$t('deposit.fpsInfo')}}</div>
        <div class="dialog-info">{{$t('deposit.hsbcInfo')}}</div>
        <div class="dialog-footer">
          <el-button type="primary" @click="showDialog = false">{{$t('common.iknow')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
  <!-- </vue-scroll> -->
</template>

<script>
import selectScroll from '../../../mixins/selectScroll.js'
// import { getEddidBanksList } from '@/api/v2/deposit'
import { mapState } from 'vuex'

export default {
  mixins: [selectScroll],
  data() {
    return {
      buttons: [],
      param: {
        title: 'depositTitle',
        links: [
          { title: 'home' },
          { title: 'depositTitle' },
          { title: 'online_bank_deposit' }
        ]
      },
      activeName: 'online_bank_deposit',
      stepInfo: {
        online_bank_deposit: {
          title: 'online_bank_deposit',
          content: [
            { stepNumer: 'step_one', stepContent: 'online_stepCon_one' },
            { stepNumer: 'step_two', stepContent: 'online_stepCon_two' },
            { stepNumer: 'step_three', stepContent: 'online_stepCon_three' },
            {
              stepNumer: 'step_four',
              stepContent: 'online_stepCon_four',
              stepContentList: 'online_stepCon_four_list'
            },
            { stepNumer: 'step_five', stepContent: 'online_stepCon_five' }
          ]
        },
        atm_transfer_deposit: {
          title: 'atm_transfer_deposit',
          content: [
            { stepNumer: 'step_one', stepContent: 'atm_stepCon_one' },
            { stepNumer: 'step_two', stepContent: 'atm_stepCon_two' },
            { stepNumer: 'step_three', stepContent: 'atm_stepCon_three' },
            {
              stepNumer: 'step_four',
              stepContent: 'atm_stepCon_four',
              stepContentList: 'atm_stepCon_four_list'
            },
            { stepNumer: 'step_five', stepContent: 'atm_stepCon_five' }
          ]
        },
        bank_transfer_deposit: {
          title: 'bank_transfer_deposit',
          content: [
            { stepNumer: 'step_one', stepContent: 'counter_stepCon_one' },
            { stepNumer: 'step_two', stepContent: 'counter_stepCon_two' },
            { stepNumer: 'step_three', stepContent: 'counter_stepCon_three' },
            { stepNumer: 'step_four', stepContent: 'counter_stepCon_four' }
          ]
        },
        cheque_deposit: {
          title: 'cheque_deposit',
          content: [
            { stepNumer: 'step_one', stepContent: 'cheque_stepCon_one' },
            { stepNumer: 'step_two', stepContent: 'cheque_stepCon_two' },
            { stepNumer: 'step_three', stepContent: 'cheque_stepCon_three' },
            { stepNumer: 'step_four', stepContent: 'cheque_stepCon_four' },
            { stepNumer: 'step_five', stepContent: 'cheque_stepCon_five' }
          ]
        },
        fps_deposit: {
          title: 'fps_deposit',
          content: [
            { stepNumer: 'step_one', stepContent: 'FPS_stepCon_one' }
          ]
        },
        sub_account_deposit: {
          title: 'sub_account_deposit',
          content: [
            { stepNumer: 'step_one', stepContent: 'subAccount_stepCon_one' },
            { stepNumer: 'step_two', stepContent: 'subAccount_stepCon_two' },
            { stepNumer: 'step_three', stepContent: 'subAccount_stepCon_three' },
            { stepNumer: 'step_four', stepContent: 'subAccount_stepCon_four' },
            { stepNumer: 'step_five', stepContent: 'subAccount_stepCon_five' }
          ]
        }
      },
      showDialog: false,
      dialogtitle: ''
    }
  },
  computed: {
    ...mapState(['subBankAccounts', 'userInfo']),
    subAccountLength() {
      return this.subBankAccounts && this.subBankAccounts.length
    }
  },
  created() {
    console.log(this.subBankAccounts, 'subBankAccounts')
  },
  async mounted() {
    if (this.$route.params.activeName) {
      this.activeName = this.$route.params.activeName
    }
    console.log(this.activeName, 'this.activeName')
    this.param.links[2].title = this.$t(
      'headerCard.breadcrumb.' + this.activeName
    )
    if (this.activeName === 'fps_deposit') {
      this.dialogtitle = this.$t('quotes.addressTips.tips')
      this.showDialog = true
    }

    // 判断该客户是否成功申请子账户，若有子账户则为其添加子账户存款方式，没有则反之(从vuex中获取就行)
    // this.$api.getsubAccount({
    //   limit: '',
    //   searchParams: {
    //     accountNumber: this.$getProfile().custom.accountNumber,
    //     status: 'completed',
    //     isLock: true
    //   },
    //   sortKey: 'createdTime',
    //   sortVal: '-1'
    // }).then(result => {
    //   var tempArr = result.data.rows
    //   // var newArr = tempArr.filter(function (obj) {
    //   //   return obj.status === 'completed'
    //   // })
    //   this.subAccountLength = tempArr.length
    // })
  },
  methods: {
    handleClick(tab, event) {
      let name = this.activeName
      this.param.links[2].title = this.$t('headerCard.breadcrumb.' + name)
      if (this.activeName === 'fps_deposit') {
        this.dialogtitle = this.$t('quotes.addressTips.tips')
        this.showDialog = true
      }
    }

  }
}
</script>

<style lang="scss">
.deposit-tab {
  height: min-content;
  .deposit-type {
    background: white;
    padding: 2rem;
    .el-tabs__nav-wrap {
      .el-tabs__item {
        font-family: Muli-Bold;
        font-size: 12px;
        color: #7d7d7d;
        letter-spacing: 0.13px;
        text-align: center;
      }
      .is-active {
        color: $main-theme-color;
      }
    }
    .el-tabs__active-bar {
      background-color: $main-theme-color;
    }
  }
  .el-collapse-item__content {
    padding-bottom: 0 !important;
  }
}
@media only screen and (max-width: 660px) {
  .deposit-tab .deposit-type {
    padding: 0;
  }
}
@media (max-width: 768px) {
  .layout-container .container .view {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
  .el-tabs__nav-scroll {
    padding: 0 10px;
  }
  .m-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .p-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.hsbc-dialog {
  .dialog-info {
    font-size: 14px;
    font-weight: 400;
    color: #7d7d7d;
    line-height: 21px;
    &:first-of-type {
      margin-bottom: 15px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 30px;
    .el-button {
      padding: 18px 96px;
      background: #fec000;
      border-radius: 5px;
      color: #192b57;
      font-size: 14px;
    }
  }
}
</style>
